import { useState } from 'react';
import './ProjectsFilter.css';
import { formStatusOptions, projectStatusOptions } from '../../utilities/services/projectsOptions';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { getProjects } from '../../utilities/api/projectsTimeline';

const defaultProjectsFilters = {
    "service": "",
    // "manager": "",
    "clientName": "",
    "intakeFormStatus": "",
    "projectStatus": "",
    // "assignee": "",
    "createdAtStart": "",
    "createdAtEnd": "",
    "updatedAtStart": "",
    "updatedAtEnd": "",
    // "submissionDateStart": "",
    // "submissionDateEnd": "",
    "dueDateStart": "",
    "dueDateEnd": "",
    "clientDeadlineStart": "",
    "clientDeadlineEnd": "",
}

export default function ProjectsFilter({ user, users, updateProjects, isMobile, services, sortHeader }) {
    const [filter, setFilter] = useState(defaultProjectsFilters)
    const [loading, setLoading] = useState(false)
    // const [activeUsers, setActiveUsers] = useState([])

    const getProjectsData = async (user) => {
        try {
            const allProjects = await getProjects(user)
            return allProjects.sort((a, b) => a[sortHeader] < b[sortHeader] ? 1 : -1)
        } catch (error) {
            console.log(error)
        }
    }

    const resetFilter = async () => {
        setLoading(true);
        // clear content of all input fields
        const form = document.getElementById('projectsFilter');
        for (let i = 0; i < form.elements.length; i++) {
            if (form.elements[i].type === 'text' || form.elements[i].type === 'date' || form.elements[i].type === 'select-one') {
                form.elements[i].value = '';
            }
        }
        setFilter(defaultProjectsFilters)
        try {
            const freshLeadsData = await getProjectsData(user);
            updateProjects(freshLeadsData)
        } catch (error) {
            console.log(error)
        }
        setLoading(false);
    }

    const filterProjects = async () => {
        setLoading(true);
        const freshProjectsData = await getProjectsData(user);
        const cleanedFilter = Object.keys(filter).reduce((acc, key) => {
            if (filter[key]) {
                acc[key] = filter[key];
            }
            return acc;
        }, {});

        try {
            const updatedProjectsList = freshProjectsData.filter(project => {
                return (
                    ((cleanedFilter.clientName) ? project.clientName.toLowerCase().includes(cleanedFilter.clientName.toLowerCase().trim()) : true) &&
                    ((cleanedFilter.service) ? project.projType === cleanedFilter.service : true) &&
                    ((cleanedFilter.assignee) ? project.assignedAnalystId === cleanedFilter.assignee : true) &&
                    ((cleanedFilter.manager) ? project.managerID === cleanedFilter.manager : true) &&
                    ((cleanedFilter.projectStatus) ? project.projectStatus === cleanedFilter.projectStatus : true) &&
                    ((cleanedFilter.intakeFormStatus) ? project.intakeFormStatus === cleanedFilter.intakeFormStatus : true) &&
                    ((cleanedFilter.createdAtStart) ? new Date(project.createdAt) >= new Date(cleanedFilter.createdAtStart) : true) &&
                    ((cleanedFilter.createdAtEnd) ? new Date(project.createdAt) <= new Date(cleanedFilter.createdAtEnd) : true) &&
                    ((cleanedFilter.updatedAtStart) ? new Date(project.updatedAt) >= new Date(cleanedFilter.updatedAtStart) : true) &&
                    ((cleanedFilter.updatedAtEnd) ? new Date(project.updatedAt) <= new Date(cleanedFilter.updatedAtEnd) : true) &&
                    ((cleanedFilter.submissionDateStart) ? new Date(project.submissionDate) >= new Date(cleanedFilter.submissionDateStart) : true) &&
                    ((cleanedFilter.submissionDateEnd) ? new Date(project.submissionDate) <= new Date(cleanedFilter.submissionDateEnd) : true) &&
                    ((cleanedFilter.dueDateStart) ? new Date(project.dueDate) >= new Date(cleanedFilter.dueDateStart) : true) &&
                    ((cleanedFilter.dueDateEnd) ? new Date(project.dueDate) <= new Date(cleanedFilter.dueDateEnd) : true) &&
                    ((cleanedFilter.clientDeadlineStart) ? new Date(project.clientDeadline) >= new Date(cleanedFilter.clientDeadlineStart) : true) &&
                    ((cleanedFilter.clientDeadlineEnd) ? new Date(project.clientDeadline) <= new Date(cleanedFilter.clientDeadlineEnd) : true)
                );
            });
            // console.log(updatedProjectsList);
            updateProjects(updatedProjectsList);
        } catch (error) {
            console.log(error)
        }
        setLoading(false);
    }

    const handleChange = (evt) => {
        const newFilterData = {
            ...filter,
            [evt.target.name]: evt.target.value
        }
        setFilter(newFilterData)
    }

    // useEffect(() => {
    //     setActiveUsers(users.filter(user => user.status === 'active'))
    //     // eslint-disable-next-line
    //   }, [users])

  return (
    <div className='ProjectsFilter dropdown projectsFilterDropDown'>
        <button className='projectsFilterDropDownToggle' id='projectsFilterDropDownToggle' title='Leads Filter' data-title='Leads Filter' data-bs-toggle="dropdown" data-bs-auto-close='outside' aria-expanded="false">
            <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            { !isMobile && <span>Filters</span> }
        </button>
        <div className='dropdown-menu projectsFilterDropDown' aria-labelledby="projectsFilterDropDownToggle">
            <div className='header'>
                <div className='svgContainer'>
                    <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <span>Filters</span>
            </div>
            <form id='projectsFilter'>
                <div className='form-group'>
                    <label htmlFor="clientName" className='form-label'>Client Name</label>
                    <input type="text" id="clientName" name='clientName' className='form-control' onChange={handleChange} value={filter.clientName} />
                </div>
                {/* <div className='form-group'>
                    <label htmlFor="manager" className='form-label'>Manager</label>
                    <select id="manager" name='manager' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { activeUsers.map((user, index) => (
                            <option key={index} value={user._id}>{capitalizeFirstLetter(user.firstName)} {capitalizeFirstLetter(user.lastName)}</option>
                        ))}
                    </select>
                </div> */}
                {/* <div className='form-group'>
                    <label htmlFor="assignee" className='form-label'>Analyst</label>
                    <select id="assignee" name='assignee' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { activeUsers.map((user, index) => (
                            <option key={index} value={user._id}>{capitalizeFirstLetter(user.firstName)} {capitalizeFirstLetter(user.lastName)}</option>
                        ))}
                    </select>
                </div> */}
                <div className='form-group'>
                    <label htmlFor="service" className='form-label'>Service</label>
                    <select id="service" name='service' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        <option value="other">Other</option>
                        { services.map((service, index) => (
                            <option key={index} value={service.code}>{service.code}</option>
                        ))}
                    </select>
                </div>
                <div>Client Deadline</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="clientDeadlineStart" className='form-label'>Start</label>
                        <input type="date" id="clientDeadlineStart" name='clientDeadlineStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="clientDeadlineEnd" className='form-label'>End</label>
                        <input type="date" id="clientDeadlineEnd" name='clientDeadlineEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                <div className='form-group'>
                    <label htmlFor="intakeFormStatus" className='form-label'>Form Status</label>
                    <select id="intakeFormStatus" name='intakeFormStatus' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { formStatusOptions.map((formStatus, index) => (
                            <option key={index} value={formStatus.value}>{capitalizeFirstLetter(formStatus.name)}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor="projectStatus" className='form-label'>Project Status</label>
                    <select id="projectStatus" name='projectStatus' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { projectStatusOptions.map((projectStatus, index) => (
                            <option key={index} value={projectStatus.value}>{capitalizeFirstLetter(projectStatus.name)}</option>
                        ))}
                    </select>
                </div>
                <div>Creation Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="createdAtStart" className='form-label'>Start</label>
                        <input type="date" id="createdAtStart" name='createdAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="createdAtEnd" className='form-label'>End</label>
                        <input type="date" id="createdAtEnd" name='createdAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                <div>Last Update</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="updatedAtStart" className='form-label'>Start</label>
                        <input type="date" id="updatedAtStart" name='updatedAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="updatedAtEnd" className='form-label'>End</label>
                        <input type="date" id="updatedAtEnd" name='updatedAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                {/* <div>Submission Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="submissionDateStart" className='form-label'>Start</label>
                        <input type="date" id="submissionDateStart" name='submissionDateStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="submissionDateEnd" className='form-label'>End</label>
                        <input type="date" id="submissionDateEnd" name='submissionDateEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div> */}
                {/* <div>Analyst Deadline</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="dueDateStart" className='form-label'>Start</label>
                        <input type="date" id="dueDateStart" name='dueDateStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="dueDateEnd" className='form-label'>End</label>
                        <input type="date" id="dueDateEnd" name='dueDateEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div> */}
            </form>
            <div className='buttonContainer'>
                <button className='btn btn-primary' type='button' onClick={filterProjects} form='projectsFilter' disabled={loading}>Filter</button>
                <button className='btn btn-secondary' type='reset' form='projectsFilter' onClick={resetFilter} disabled={loading}>Reset</button>
            </div>
            { loading &&
            <div className='loading'>
                <div className="spinner-border" role="status"></div>
            </div>
            }
        </div>
    </div>
  )
}
